<script setup lang="ts">
import { ref, watch } from 'vue';
import { TEXT } from '../../configs/text';
import { useI18n } from 'petite-vue-i18n';
import { useSessionStore } from '../../stores';
import { utils } from '../../utils';
import Modal from '../General/Modal.vue';
import Isaac from '../General/Isaac.vue';

const session = useSessionStore()

const modalShow = ref<boolean>(false)
const defaultTimeLeft = 3
const timeLeft = ref<number>(defaultTimeLeft)
let notiInterval: NodeJS.Timeout | null = null

watch(() => session.teacherSession, () => {
    if (notiInterval) clearInterval(notiInterval)

    if (!session.teacherSession) {
        modalShow.value = false
        return
    }

    modalShow.value = true
    timeLeft.value = defaultTimeLeft
    notiInterval = setInterval(() => {
        timeLeft.value--
        if (timeLeft.value >= 0) return;

        timeLeft.value = 0
        modalShow.value = false
        if (!notiInterval) return;
        clearInterval(notiInterval)
    }, 1000)
})

const { t } = useI18n()
</script>

<template>
    <Modal v-model="modalShow" :static="true" :close-btn="false" :transparent="true" size="medium">
        <template #backdrop>
            <div class="fixed inset-0 bg-black/90"></div>
        </template>
        <div class="flex flex-col items-center gap-5">
            <Isaac :text="t(TEXT.teacher_forced_screen, {
                session: session.teacherSession && t(utils.getSessionName(session.teacherSession))
            })" />
            <div class="size-20 rounded-full flex items-center justify-center bg-neutral-200 p-3 text-3xl">
                {{ timeLeft }}
            </div>
        </div>
    </Modal>
</template>